var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChainLinkWithBorders = function SvgChainLinkWithBorders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 8,
    stroke: "#2E3330",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel",
    strokeDasharray: "10 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6538 26.7988L17.8243 27.6282C17.0732 28.3793 16.0545 28.8013 14.9923 28.8013C13.9301 28.8013 12.9114 28.3793 12.1603 27.6282C11.4093 26.8772 10.9873 25.8585 10.9873 24.7963C10.9873 23.7341 11.4093 22.7154 12.1603 21.9643L16.4083 17.7154C17.1205 17.0016 18.0758 16.5827 19.0833 16.5424C20.0908 16.5021 21.0765 16.8433 21.8435 17.4979C22.6104 18.1525 23.1023 19.0723 23.2207 20.0736C23.3392 21.075 23.0756 22.0842 22.4826 22.8997",
    stroke: "#2E3330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5077 15.2884L24.1752 14.6209C24.9263 13.8698 25.945 13.4479 27.0072 13.4479C28.0694 13.4479 29.0881 13.8698 29.8392 14.6209C30.5903 15.372 31.0122 16.3907 31.0122 17.4529C31.0122 18.5151 30.5903 19.5338 29.8392 20.2849L25.5912 24.5329C24.8789 25.2464 23.9236 25.6649 22.9162 25.705C21.9088 25.7451 20.9233 25.4038 20.1565 24.7491C19.3897 24.0945 18.8981 23.1747 18.7797 22.1734C18.6613 21.1722 18.9249 20.1631 19.5179 19.3477",
    stroke: "#2E3330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgChainLinkWithBorders;